import { useEffect, useState } from "react";

import { LoadingDots } from "@/components/_molecules/loading-dots/loading-dots";
import { useSaveDatatableState } from "@/domain/view/hooks/api/use-save-datatable-state";
import { useCurrentViewContext } from "@/domain/view/hooks/use-current-view-context";

import { DatatableRowData } from "../datatable-types";

import { type InternalDataTableContextProviderProps } from "./datatable-context-props";
import { PrepareInitialContextWithUrlParams } from "./prepare-initial-context-with-url-params";

type LoadPhase = "loading" | "resolved";

export const PrepareInitialContextWithAPIState = <TData extends DatatableRowData>(
  props: InternalDataTableContextProviderProps<TData>,
) => {
  const { currentDatatableState, currentActiveView, isLoading } = useCurrentViewContext();
  const { saveDatatableState } = useSaveDatatableState({
    activeViewId: currentActiveView?.id,
    workspaceId: props.workspaceId,
    viewKey: props.viewKey,
  });

  const [loadPhase, setLoadPhase] = useState<LoadPhase>(isLoading ? "loading" : "resolved");

  useEffect(() => {
    if (!isLoading) {
      setLoadPhase("resolved");
    }
  }, [isLoading]);

  if (loadPhase === "loading") {
    return (
      <div className="flex h-full w-full items-center justify-center" data-testid="loading-dots">
        <LoadingDots />
      </div>
    );
  }

  return (
    <PrepareInitialContextWithUrlParams
      {...props}
      initialState={currentDatatableState}
      saveDatatableState={saveDatatableState}
    />
  );
};
